<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-alert dense text type="error" v-if="isCompletingData">
          <strong> صنعتگر محترم</strong> اطلاعات کسب و کار شما هنوز کامل نشده
          است لطفاً
          <strong>در ادامه </strong>
          اطلاعات باقی مانده را تکمیل و پس از ذخیره آنرا
          <strong>جهت بررسی و انتشار </strong> ارسال نمایید.
        </v-alert>
      </v-col>
    </v-row>
    <v-stepper
      v-model="stepper"
      vertical
      class="elevation-0"
      id="BusinessRegistrationForm"
    >
      <v-stepper-step
        step="1"
        :complete="stepper > 1"
        class="p-1"
        :color="stepper > 1 ? 'success' : 'primary'"
      >
        <span v-if="submitAsBuyerFlag">اطلاعات کاربر</span>
        <span v-else>اطلاعات صاحب کسب و کار</span>
      </v-stepper-step>
      <v-stepper-content step="1" class="pl-0 pr-1 ml-1 mr-2">
        <v-card class="stepper-content" elevation="0">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <BusinessOwnerInfo
                  :validateOwnerInfo="validateOwnerInfo"
                  @nextStep="nextStep"
                  @validationFailed="validationFailed"
                  @submitAsBuyerFlagChange="submitAsBuyerFlagChange"
                  @setFullInfoSubmitionData="setFullInfoSubmitionData"
                  @changeTaksaanTerms="changeTaksaanTerms"
                  :isEdit="isEdit"
                  :businessRegistrationData="
                    isEdit || addNewMerchantCompany
                      ? businessRegistrationData
                      : null
                  "
                  :merchantIsApproved="merchantIsApproved"
                  :merchantMonitorFields="merchantMonitorFields"
                  :addNewMerchantCompany="addNewMerchantCompany"
                ></BusinessOwnerInfo>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!taksaanTerms"
              :color="setFullInfoSubmition ? 'primary' : 'success'"
              @click="
                !setFullInfoSubmition
                  ? (submitFlag = true)
                  : (submitFlag = false);
                validation('validateOwnerInfo');
              "
              >{{ setFullInfoSubmition ? 'گام بعد' : 'ثبت' }}
              <v-icon>mdi-step-backward</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-step
        step="2"
        :complete="stepper > 2"
        v-if="setFullInfoSubmition"
        class="p-1"
        :color="stepper > 2 ? 'success' : 'primary'"
      >
        اطلاعات کسب و کار
      </v-stepper-step>
      <v-stepper-content step="2" class="pl-0 pr-1 ml-1 mr-2">
        <v-card class="stepper-content">
          <!-- :nameForCompany="
                ownerInfoForm && ownerInfoForm.managerPerson
                  ? ownerInfoForm.managerPerson.firstName +
                    ' ' +
                    ownerInfoForm.managerPerson.lastName
                  : null
              " -->
          <v-card-text>
            <BusinessDetail
              :validateDetail="validateDetail"
              @nextStep="nextStep"
              @validationFailed="validationFailed"
              :isEdit="isEdit"
              :businessRegistrationData="
                isEdit || addNewMerchantCompany
                  ? businessRegistrationData
                  : null
              "
              :merchantIsApproved="merchantIsApproved"
              :merchantMonitorFields="merchantMonitorFields"
              :addNewMerchantCompany="addNewMerchantCompany"
            ></BusinessDetail>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="stepper = 1">
              <v-icon>mdi-step-forward</v-icon>
              گام قبل</v-btn
            >
            <v-btn color="primary" @click="validation('validateDetail')"
              >گام بعد
              <v-icon>mdi-step-backward</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>

      <v-stepper-step
        step="3"
        :complete="stepper > 3"
        v-if="setFullInfoSubmition"
        class="p-1"
        :color="stepper > 3 ? 'success' : 'primary'"
      >
        اطلاعات آدرس
      </v-stepper-step>
      <v-stepper-content step="3" class="pl-0 pr-1 ml-1 mr-2">
        <v-card class="stepper-content">
          <v-card-text>
            <BusinessAddress
              :validateBusinessAddress="validateBusinessAddress"
              @nextStep="nextStep"
              @validationFailed="validationFailed"
              :isEdit="isEdit"
              :businessRegistrationData="
                isEdit ? businessRegistrationData : null
              "
              :merchantIsApproved="merchantIsApproved"
              :merchantMonitorFields="merchantMonitorFields"
            ></BusinessAddress>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="stepper = 2">
              <v-icon>mdi-step-forward</v-icon>
              گام قبل</v-btn
            >
            <v-btn
              color="primary"
              v-if="!submitAsBuyerFlag"
              @click="validation('validateBusinessAddress')"
              >گام بعد
              <v-icon>mdi-step-backward</v-icon>
            </v-btn>
            <v-btn
              v-if="submitAsBuyerFlag"
              :color="isEdit ? 'primary' : 'success'"
              @click="
                submitFlag = isEdit ? false : true;
                validation('validateBusinessAddress');
              "
            >
              {{ isEdit ? 'گام بعد' : 'ذخیره' }}
              <v-icon>mdi-step-backward</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-step
        step="4"
        :complete="stepper > 4"
        v-if="setFullInfoSubmition && !submitAsBuyerFlag"
        class="p-1"
        :color="stepper > 4 ? 'success' : 'primary'"
      >
        اطلاعات حوزه فعالیت
      </v-stepper-step>
      <v-stepper-content
        step="4"
        class="pl-0 pr-1 ml-1 mr-2"
        v-if="setFullInfoSubmition && !submitAsBuyerFlag"
      >
        <v-card class="stepper-content">
          <v-card-text>
            <BusinessActivityCategory
              :validateActivityCategory="validateActivityCategory"
              @nextStep="nextStep"
              @setValidateActivityCategory="setValidateActivityCategory"
              @validationFailed="validationFailed"
              :isManufacturer="
                ownerInfoForm ? ownerInfoForm.isManufacturer : false
              "
              :isEdit="isEdit"
              :businessRegistrationData="
                isEdit ? businessRegistrationData : null
              "
              :merchantIsApproved="merchantIsApproved"
              :merchantMonitorFields="merchantMonitorFields"
            >
            </BusinessActivityCategory>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="stepper = 3">
              <v-icon>mdi-step-forward</v-icon> گام قبل
            </v-btn>
            <v-btn
              :disabled="!activityCategoryIsValid"
              :color="isEdit ? 'primary' : 'success'"
              @click="
                submitFlag = isEdit ? false : true;
                validation('validateActivityCategory');
              "
            >
              {{ isEdit ? 'گام بعد' : 'ذخیره و ادامه' }}
              <v-icon>mdi-step-backward</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-step
        :step="submitAsBuyerFlag ? 4 : 5"
        :complete="submitAsBuyerFlag ? stepper > 4 : stepper > 5"
        v-if="setFullInfoSubmition && isEdit"
        class="p-1"
        :color="
          (submitAsBuyerFlag && stepper > 4) ||
          (!submitAsBuyerFlag && stepper > 5)
            ? 'success'
            : 'primary'
        "
      >
        اطلاعات تکمیلی
      </v-stepper-step>
      <v-stepper-content
        :step="submitAsBuyerFlag ? 4 : 5"
        v-if="isEdit"
        class="pl-0 pr-1 ml-1 mr-2"
      >
        <v-card class="stepper-content">
          <v-card-text>
            <business-other-info
              :validateOtherInfo="validateOtherInfo"
              @nextStep="nextStep"
              @validationFailed="validationFailed"
              :isEdit="isEdit"
              :businessRegistrationData="
                isEdit ? businessRegistrationData : null
              "
              :merchantIsApproved="merchantIsApproved"
              :merchantMonitorFields="merchantMonitorFields"
            >
            </business-other-info>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12">
                <!-- <v-btn
              color="success"
              @click="(submitFlag = true), validation('validateOtherInfo')"
              >ذخیره</v-btn
            > -->

                <!-- <v-btn
               :block =$vuetify.breakpoint.smAndDown 
              class="ma-2"
              :loading="loading"
              :disabled="loading"
              color="info"
              @click="
                (submitFlag = true),
                  (loader = 'loading'),
                  validation('validateOtherInfo')
              "
            >
              ذخیره و ارسال جهت تائید و انتشار
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn> -->
                <v-btn
                  :block="$vuetify.breakpoint.smAndDown"
                  color="error"
                  @click="stepper = submitAsBuyerFlag ? 3 : 4"
                >
                  <v-icon>mdi-step-forward</v-icon>
                  گام قبل
                </v-btn>
                <v-btn
                  :block="$vuetify.breakpoint.smAndDown"
                  class="ma-2"
                  :loading="loading"
                  :disabled="loading"
                   :color="isCompletingData ? 'light-green accent-3': 'primary'"
                  @click="
                    (submitFlag = true),
                      (loader = 'loading'),
                      validation('validateOtherInfo')
                  "
                >
                  {{ isCompletingData ? 'ذخیره و ارسال جهت انتشار' : 'ذخیره ' }}

                  <v-icon>mdi-check-decagram</v-icon>
                  <template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </template>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper>
    <v-dialog v-model="showFinalDialog" persistent max-width="550">
      <!-- <div>
        <v-alert
          v-model="consumerCreationAlert"
          color="blue-darken-3"
          variant="tonal"
          closable
        >
          <v-stepper>
            <v-stepper-header>
              <v-stepper-item
                title="ایجاد کسب و کار "
                value="1"
                :complete="consumerCreated"
              ></v-stepper-item>
              <v-divider></v-divider>

              <v-stepper-item
                title="شارژ اعتبار "
                value="2"
                :complete="walletCharged"
              ></v-stepper-item>

              <v-divider></v-divider>

              <v-stepper-item
                title="ایجاد اشتراک پایه "
                value="3"
                :complete="baseMembershipCreated"
              ></v-stepper-item>

              <v-divider></v-divider>

              <v-stepper-item
                title="فعال سازی اشتراک پایه "
                value="4"
                :complete="baseMemberShipActivated"
              ></v-stepper-item>
            </v-stepper-header>
          </v-stepper>
        </v-alert>
      </div> -->
      <v-card>
        <v-toolbar color="indigo" dark>
          <div class="d-flex justify-space-between align-center w--100">
            <span class="white--text font-weight-bold">
              ادامه ثبت نام در پنل موقت
            </span>
            <div class="font-s">
              {{ timer }} <v-icon class="mdi mdi-timer"></v-icon>
            </div>
          </div>
        </v-toolbar>
        <v-card-text>
          <div class="d-flex flex-column justify-start align-start pa-2 my-2">
            <template v-if="submitAsBuyerFlag">
              <h4 class="h4">
                خریدار گرامی، شما تا چند لحظه دیگر وارد پنل خریدار می شوید.
              </h4>

              <h4 class="h4">در این پنل شما به موارد زیر دسترسی دارید:</h4>

              <ul>
                <li>
                  امکان ثبت سفارشات استعلام، مناقصه، شناسایی پیمانکار و مدیریت
                  انها
                </li>

                <li>امکان تبدیل وضعیت به تامین کننده</li>

                <li>تکمیل اطلاعات بیشتری از کسب و کار</li>

                <li>مشاهده و ویرایش اطلاعات ثبت شده در این مرحله</li>

                <li>
                  بارگزاری مدارک مورد نیاز برای تکمیل اطلاعات کسب و کار یا
                  خریدار که ثبت کرده‌اید
                </li>

                <li>
                  امکان ارسال و دریافت پیام با پشتیبان سایت در خصوص موضوعات
                  مختلف
                </li>
              </ul>
            </template>
            <template v-else>
              <h4 class="h4">
                تامین کننده گرامی، شما در حال
                <strong>انتقال به پنل موقت</strong> هستید تا اطلاعات خود را
                تکمیل کرده و به ادمین تکصان ارسال کنید .
              </h4>

              <h4 class="h4">در این پنل شما به موارد زیر دسترسی دارید:</h4>

              <ul>
                <li>بازنگری و تکمیل حوزه فعالیت</li>
                <li>تکمیل اطلاعات بیشتری از کسب و کار</li>
                <li>مشاهده و ویرایش اطلاعات ثبت شده در در صورت نیاز</li>
                <li>
                  پس از تکمیل اطلاعات، از طریق لینک
                  <strong> ارسال جهت تایید و انتشار</strong>
                  آنرا به ادمین ارسال کنید.
                </li>

                <li>
                  امکان ارسال و دریافت پیام با پشتیبان سایت در خصوص موضوعات
                  مختلف
                </li>
              </ul>
            </template>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn
            :disabled="timer >= 20"
            color="orange accent-4"
            class="white--text"
            @click="navTo()"
            ><span>متوجه شدم - ادامه</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BusinessOwnerInfo from './BusinessOwnerInfo.vue';
import BusinessDetail from './BusinessDetail.vue';
import BusinessAddress from './BusinessAddress.vue';
import BusinessActivityCategory from './BusinessActivityCategory.vue';
import { RepoFactory } from '@/baseRepository/Factory';
const supplierRepository = () => RepoFactory.get('supplier');
const merchantRepository = () => RepoFactory.get('merchant');
const merchantCompanyRepository = () => RepoFactory.get('merchantCompany');
const walletTransactionsRepository = () =>
  RepoFactory.get('walletTransactions');
const subscriptionRepository = () => RepoFactory.get('subscription');
const paymentRepository = () => RepoFactory.get('payment');
import BusinessOtherInfo from './BusinessOtherInfo.vue';
import { stringify } from 'qs';
import Helper from '@/core/helpers';
function beforeunloadFunc(e) {
  var confirmationMessage = 'آیا میخواهید صفحه را ترک کنید؟ ';

  (e || window.event).returnValue = confirmationMessage;
}
export default {
  components: {
    BusinessOwnerInfo,
    BusinessDetail,
    BusinessAddress,
    BusinessActivityCategory,
    BusinessOtherInfo,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    businessRegistrationData: {
      type: Object,
      default: null,
    },
    editMerchant: {
      type: Boolean,
      default: false,
    },
    merchantMonitorFields: {
      type: Object,
      default: null,
    },
    addNewMerchantCompany: {
      type: Boolean,
      default: false,
    },
    editStep: {
      type: Number,
      default: 1,
    },
    // در حال ثبت نام و تکمیل اطلاعات
    //مقدار این فیلد خیلی مهم هست فقط برای حالت تکمیل ثبت نام باید مقدار ترو بگیرد
    // چون اگر ترو بود هم ذخیره و هم ارسال به ادمین انجام می‌شود
    // در بقیه موارد فقط ذخیره باید انجام شود
    isCompletingData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stepper: 1,
      activityCategoryIsValid:false,
      validateOwnerInfo: false,
      validateDetail: false,
      validateBusinessAddress: false,
      validateActivityCategory: false,
      validateOtherInfo: false,
      submitAsBuyerFlag: false,
      setFullInfoSubmition: false,
      taksaanTerms: false,
      submitFlag: false,

      ownerInfoForm: null,
      bOwnerInfoForm: {
        creatorIsManager: true,
        isManufacturer: true,
        managerPerson: {
          firstName: null,
          lastName: null,
          gender: 'Male',
          birthdate: null,
          nationalCode: null,
          memberType: 'Manager',
          mobile: '',
        },
        creatorPerson: {
          firstName: null,
          lastName: null,
          gender: 'Male',
          birthdate: null,
          nationalCode: null,
          memberType: 'Other',
        },
      },
      businessDetailForm: null,
      //To make form without loading component
      bDetailForm: {
        phones: [
          {
            title: 'کار',
            type: 'Work',
            phoneNumber: null,
          },
          {
            title: 'همراه',
            type: 'Mobile',
            phoneNumber: null,
          },
        ],
        company: {
          name: null,
          brandName: null,
          nationalId: null,
          registrarNumber: null,
          economicCode: null,
          taxCode: null,
          companyType: null,
          isic: null,
          guildId: null,
        },
        email: '',
        name: '',
        yearOfFoundation: '',
        numberOfEmployee: null,
        permittedSignerNames: [],
      },
      businessAddressForm: null,
      bAddressForm: {
        address: {
          title: 'آدرس ثبت شده در فرایند ثبت نام',
          cityId: null,
          neighbourhoodId: null,
          addressLane: null,
          postalCode: null,
          no: null,
          unit: null,
          latitude: null,
          longitude: null,
        },
      },
      activityCategoryForm: null,
      bActivitycatForm: {
        isManufacturer: null,
        categoryIds: [],
        categoryTypes: [],
      },
      otherInfoForm: null,
      supplierBody: null,
      buyersFormBody: null,
      timer: 25,
      showFinalDialog: false,
      consumerCreated: false,
      walletCharged: false,
      baseMembershipCreated: false,
      baseMemberShipActivated: false,
      directOrderConfirmation: false,
      registeredDirectOrderId: 0,
      consumerCreationAlert: false,
      loader: null,
      loading: false,
    };
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    merchantIsApproved() {
      if (this.editMerchant) {
        if (this.businessRegistrationData.status == 'Approved') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    walletBaseUrl() {
      return this.$store.getters.walletBaseUrl;
    },
    paymentBaseUrl() {
      return this.$store.getters.paymentBaseUrl;
    },
    subscriptionBaseUrl() {
      return this.$store.getters.subscriptionBaseUrl;
    },
  },
  watch: {
    stepper() {
      document.getElementById('BusinessRegistrationForm').scrollIntoView();
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 6000);

      this.loader = null;
    },
  },
  created() {
    this.stepper = this.editStep;
    this.loadComponents(this.editStep, this.businessRegistrationData);
    if (this.isEdit && !this.editMerchant) {
      this.submitAsBuyerFlag = !this.businessRegistrationData.isSupplier;
    } else if (this.editMerchant) {
      this.submitAsBuyerFlag = false;
    }
  },
  methods: {
    ...mapActions('oidc', ['signOutOidc', 'authenticateOidc']),
    submitAsBuyerFlagChange(status) {
      this.submitAsBuyerFlag = status;
    },
    setFullInfoSubmitionData(status) {
      this.setFullInfoSubmition = status;
      //this.stepper = 1;
    },
    changeTaksaanTerms(status) {
      this.taksaanTerms = status;
    },
    setValidateActivityCategory(value) {
      this.activityCategoryIsValid = value;
    },
    validation(validationType) {
      if (validationType == 'validateOwnerInfo') {
        this.validateOwnerInfo = true;
      } else if (validationType == 'validateDetail') {
        this.validateDetail = true;
      } else if (validationType == 'validateBusinessAddress') {
        this.validateBusinessAddress = true;
      } else if (validationType == 'validateActivityCategory') {
        this.validateActivityCategory = true;
      } else if (validationType == 'validateOtherInfo') {
        this.validateOtherInfo = true;
      }
    },
    validationFailed() {
      this.validateOwnerInfo = false;
      this.validateDetail = false;
      this.validateBusinessAddress = false;
      this.validateActivityCategory = false;
      this.validateOtherInfo = false;

      this.$dialog.error({
        text: 'وارد کردن موارد ستاره دار الزامی میباشد',
        title: 'خطا',
        persistent: true,
        actions: [
          {
            text: 'بستن',
            color: 'red',
          },
        ],
      });
    },
    nextStep(form, source) {
      this.validateOwnerInfo = false;
      this.validateDetail = false;
      this.validateBusinessAddress = false;
      this.validateActivityCategory = false;
      this.validateOtherInfo = false;
      this.supplierBody = {};
      this.buyersFormBody = {};
      if (source == 'ownerInfo') {
        this.ownerInfoForm = form;
      } else if (source == 'businessDetail') {
        this.businessDetailForm = form;
      } else if (source == 'businessAddress') {
        this.businessAddressForm = form;
      } else if (source == 'activityCategory') {
        this.activityCategoryForm = form;
      } else if (source == 'otherInfo') {
        this.otherInfoForm = form;
      }

      if (this.submitAsBuyerFlag) {
        this.ownerInfoForm.isManufacturer = false;
        this.buyersFormBody = {
          ...this.ownerInfoForm,
          ...this.businessDetailForm,
          ...this.businessAddressForm,
          ...this.otherInfoForm,
        };
      } else {
        let visitorsPhoneList = {
          visitorPhoneList: this.$store.getters.visitorsPhoneList,
        };
        this.supplierBody = {
          ...this.ownerInfoForm,
          ...this.businessDetailForm,
          ...this.businessAddressForm,
          ...this.activityCategoryForm,
          ...this.otherInfoForm,
          ...visitorsPhoneList,
        };
      }
      if (!this.isEdit) {
        if (!this.setFullInfoSubmition && this.submitFlag) {
          let otherReqData = {
            company: {
              name:
                this.ownerInfoForm.managerPerson.firstName +
                ' ' +
                this.ownerInfoForm.managerPerson.lastName,
              brandName: null,
              nationalId: null,
              registrarNumber: null,
              economicCode: null,
              taxCode: null,
              companyType: 'PersonalBusiness',
              isic: null,
              guildId: null,
            },
            name:
              this.ownerInfoForm.managerPerson.firstName +
              ' ' +
              this.ownerInfoForm.managerPerson.lastName,
            phones: [
              {
                title: 'همراه',
                type: 'Mobile',
                phoneNumber: this.ownerInfoForm.managerPerson.mobile,
              },
            ],
          };

          if (this.submitAsBuyerFlag) {
            this.buyersFormBody = {
              ...otherReqData,
              ...this.ownerInfoForm,
            };
            this.submitAsBuyer();
          } else {
            this.supplierBody = {
              ...otherReqData,
              ...this.ownerInfoForm,
            };
            if (this.$store.getters.currentUserIsVisitor) {
              let visitorsPhoneList = {
                visitorPhoneList: this.$store.getters.visitorsPhoneList,
              };
              this.supplierBody = {
                ...otherReqData,
                ...this.ownerInfoForm,
                ...visitorsPhoneList,
              };
            }
            // redirectToEditForm if this.submitFlag==true;

            this.saveSupplier();
          }
        } else if (this.setFullInfoSubmition && this.submitFlag) {
          if (this.submitAsBuyerFlag) {
            this.submitAsBuyer();
          } else {
            if (this.addNewMerchantCompany) {
              this.addMerchantCompany();
            } else {
              this.saveSupplier();
            }
          }
        } else {
            this.stepper++;
        }
      } else {
        if (this.submitFlag) {
          if (this.editMerchant) {
            if (this.merchantIsApproved) {
              this.editMerchantApproved();
            } else {
              this.editMerchantCompany();
            }
          } else {
            if (this.submitAsBuyerFlag) {
              this.editSupplierAsConsumer();
            } else {
              this.editSupplier();
            }
          }
        } else {
            this.stepper++;
        }
      }
    },
    loadComponents(toStep, data) {
      if (toStep == 2) {
        this.fillValueOfBusinessOwnerInfo(data);
        this.nextStep(this.bOwnerInfoForm, 'ownerInfo');
        this.stepper = 2;
      }
      if (toStep == 5) {
        this.fillValueOfBusinessOwnerInfo(data);
        this.nextStep(this.bOwnerInfoForm, 'ownerInfo');
        this.fillValueOfbusinessDetail(data);
        this.nextStep(this.bDetailForm, 'businessDetail');
        this.fillValueOfAddess(data);
        this.nextStep(this.bAddressForm, 'businessAddress');
        this.fillValueBusinessActivity(data);
        this.nextStep(this.bActivitycatForm, 'activityCategory');
        this.stepper = 5;
      }
    },
    addMerchantCompany() {
      const loader = this.$loading.show();
      merchantCompanyRepository()
        .addMerchantCompany(this.supplierBody, this.merchantBaseUrl, {
          MerchantId: this.businessRegistrationData.merchantId,
        })
        .then(() => {
          this.closeForm();
          this.$dialog.message.success('با موفقیت ویرایش شد. ', {
            position: 'top-left',
          });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    editMerchantApproved() {
      const loader = this.$loading.show();
      merchantCompanyRepository()
        .editMerchantApproved(this.supplierBody, this.merchantBaseUrl, {
          MerchantId: this.businessRegistrationData.merchantId,
        })
        .then(() => {
          this.closeForm();
          this.$dialog.message.success('با موفقیت ویرایش شد. ', {
            position: 'top-left',
          });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    editMerchantCompany() {
      console.log(this.supplierBody);
      const loader = this.$loading.show();
      merchantCompanyRepository()
        .editMerchantCompany(this.supplierBody, this.merchantBaseUrl, {
          MerchantId: this.businessRegistrationData.merchantId,
        })
        .then(() => {
          this.closeForm();
          this.$dialog.message.success('با موفقیت ویرایش شد. ', {
            position: 'top-left',
          });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    editSupplierAsConsumer() {
      const loader = this.$loading.show();
      supplierRepository()
        .editSupplierAsConsumer(this.buyersFormBody, this.merchantBaseUrl)

        .then(() => {
          this.closeForm();
          this.$dialog.message.success('با موفقیت ویرایش شد. ', {
            position: 'top-left',
          });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
          this.submitFlag = false;
        });
    },
    editSupplier() {
      //Check if visitor is editing
      if (this.$store.getters.currentUserIsVisitor) {
        const loader = this.$loading.show();
        supplierRepository()
          .editSupplierByVisitor(
            this.businessRegistrationData.merchantId,
            this.supplierBody,
            this.merchantBaseUrl
          )
          .then(() => {
            this.closeForm();
           
             this.$dialog.message.success('ویرایش انجام شد. ', {
              position: 'top-left',
            });
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          })
          .finally(() => loader.hide());
      } else {
        const loader = this.$loading.show();
        supplierRepository()
          .editSupplier(this.supplierBody, this.merchantBaseUrl)
          .then(() => {
            //Check if Send to Confirm in Completeing Supplier Data
             console.log("Befor Calling Confirm Function1")
            if (this.isCompletingData && (this.businessRegistrationData.status == 'Draft' || this.businessRegistrationData.status == 'Rejected')) {
              console.log("Befor Calling Confirm Function2")
              this.sendRequestForConfirmation();
            }
          
            ///---------------
            this.closeForm();
            this.$dialog.message.success('با موفقیت ویرایش شد. ', {
              position: 'top-left',
            });
          })
          .catch((error) => {
            console.log('Error on Editing Supplier:', error);
            Helper.handleErrors(error, this);
          })
          .finally(() => {
            loader.hide();
            this.submitFlag = false;
          });
      }
    },
    closeForm() {
      this.$emit('closeForm');
    },
    submitAsBuyer() {
      const loader = this.$loading.show();
      console.log("this.buyersFormBody",this.buyersFormBody)
      supplierRepository()
        .createBuyer(this.buyersFormBody, this.merchantBaseUrl)
        .then(() => {
          this.consumerCreationAlert = true;
          this.chargeConsumerOwnerUserWallete(false);
          this.creteMembershipBasePlanForConsumer(res.data.id, false);
          this.consumerCreated = true;

          this.showFinalDialog = true;
          window.removeEventListener('beforeunload', beforeunloadFunc);
          setInterval(() => {
            if (this.timer > 0) {
              this.timer -= 1;
            }
          }, 1000);
          setTimeout(() => {
            this.authenticateOidc();
          }, 15000);
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        })
        .finally(() => {
          loader.hide();
          this.submitFlag = false;
        });
    },
    //Create supplier
    saveSupplier() {
      const loader = this.$loading.show();
      supplierRepository()
        .createSupplier(this.supplierBody, this.merchantBaseUrl)
        .then((res) => {
          this.showFinalDialog = true;
          this.consumerCreationAlert = true;
          this.chargeConsumerOwnerUserWallete(res.data.id, true);
          this.creteMembershipBasePlanForConsumer(res.data.id, true);
          this.consumerCreated = true;

          window.removeEventListener('beforeunload', beforeunloadFunc);
          setInterval(() => {
            if (this.timer > 0) {
              this.timer -= 1;
            }
          }, 1000);
          setTimeout(() => {
            this.authenticateOidc();
          }, 15000);
        })
        .catch((error) => {
          console.log('Error on Creating Supplier:', error);
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
          this.submitFlag = false;
        });
    },
    navTo() {
      window.removeEventListener('beforeunload', beforeunloadFunc);
      this.authenticateOidc();
    },
    async chargeConsumerOwnerUserWallete(consumerId, isSupplier) {
      const loader = this.$loading.show();
      let monyAmout = 0;

      if (isSupplier) {
        monyAmout = this.$store.getters.autoChargeMonyForConsumerFounderUser
          ? this.$store.getters.autoChargeMonyForConsumerFounderUser
          : 1000;
      } else {
        monyAmout = this.$store.getters.autoChargeMonyForSupplierFounderUser
          ? this.$store.getters.autoChargeMonyForSupplierFounderUser
          : 1000;
      }

      let chargeBody = {
        credit: {
          currency: 'IRR',
          amount: Number(monyAmout),
        },
        merchantId: Number(consumerId),
      };
      await walletTransactionsRepository()
        .chargeWallByConsumerOwnerUser(chargeBody, this.walletBaseUrl)
        .then((res) => {
          console.log('AutoCharge wallete Success Data is:');
          console.log(res);
          this.walletCharged = true;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    async creteMembershipBasePlanForConsumer(consumerId, isSupplier) {
      const loader = this.$loading.show();
      let subscriptionPlanId = 0;

      if (isSupplier) {
        subscriptionPlanId = this.$store.getters
          .subscriptionBasePlaneForSuppliersId
          ? this.$store.getters.subscriptionBasePlaneForSuppliersId
          : 0;
      } else {
        subscriptionPlanId = this.$store.getters
          .subscriptionBasePlaneForBuyersId
          ? this.$store.getters.subscriptionBasePlaneForBuyersId
          : 0;
      }

      let body = {
        subscriptionPlanId: Number(subscriptionPlanId),
      };
      await subscriptionRepository()
        .autoCreateBaseMemershipPlan(body, this.subscriptionBaseUrl, {
          MerchantId: consumerId,
        })
        .then((res) => {
          console.log('AutoMembership creation Success Data is:');
          console.log(res);
          this.baseMembershipCreated = true;
          //pay by wallet to activate membership
          this.payMembershipPlan(consumerId, res.data.id, isSupplier);
          loader.hide();
        })
        .catch((err) => {
          console.log('333333');
          console.log(err);
          loader.hide();
          Helper.handleErrors(err, this);
        })
        .finally(() => {
          loader.hide();
        });

      // baseMemberShipActivated,
    },

    async payMembershipPlan(consumerId, membershipId, isSupplier) {
      const loader = this.$loading.show();
      let cost = 0;
      if (isSupplier) {
        cost = this.$store.getters.baseMembershipforSupplierCost
          ? this.$store.getters.baseMembershipforSupplierCost
          : 100;
      } else {
        cost = this.$store.getters.baseMembershipforConsumerCost
          ? this.$store.getters.baseMembershipforConsumerCost
          : 100;
      }

      let body = {
        sourceObjectId: membershipId,
        amount: {
          currency: 'IRR',
          amount: cost,
        },
        receiverMerchantId: null,
        payerMerchantId: consumerId,
        sourceType: 'Membership',
      };
      await paymentRepository()
        .payByWallet(body, this.paymentBaseUrl)
        .then((res) => {
          console.log(
            'Auto Pay Membership cost from payment service Success Data is:'
          );
          console.log(res);
          this.baseMemberShipActivated = true;
          //pay by wallet to activate membership
        })
        .catch((err) => {
          Helper.handleErrors(err, this);

          console.log('errorStatue');
          console.log(err);
        })
        .finally(() => {
          loader.hide();
        });

      // baseMemberShipActivated,
    },
    //Filling component data for in Edit mode --Start
    fillValueOfBusinessOwnerInfo(data) {
      this.bOwnerInfoForm.managerPerson.id = data.managerPerson.id;
      this.bOwnerInfoForm.creatorPerson.id = data.creatorPerson.id;
      this.bOwnerInfoForm.managerPerson.firstName =
        data.managerPerson.firstName;
      this.bOwnerInfoForm.managerPerson.lastName = data.managerPerson.lastName;
      this.bOwnerInfoForm.managerPerson.gender = data.managerPerson.gender
        ? data.managerPerson.gender
        : null;
      this.bOwnerInfoForm.managerPerson.birthdate =
        data.managerPerson.birthdate;
      this.bOwnerInfoForm.managerPerson.nationalCode = data.managerPerson
        .nationalCode
        ? data.managerPerson.nationalCode
        : null;
      this.bOwnerInfoForm.managerPerson.mobile = data.managerPerson.mobile;
      this.bOwnerInfoForm.creatorPerson.firstName =
        data.creatorPerson.firstName;
      this.bOwnerInfoForm.creatorPerson.lastName = data.creatorPerson.lastName;
      this.bOwnerInfoForm.creatorPerson.gender = data.creatorPerson.gender
        ? data.creatorPerson.gender
        : null;
      this.bOwnerInfoForm.creatorPerson.birthdate =
        data.creatorPerson.birthdate;
      this.bOwnerInfoForm.creatorPerson.nationalCode = data.creatorPerson
        .nationalCode
        ? data.creatorPerson.nationalCode
        : null;
      this.bOwnerInfoForm.creatorIsManager = data.creatorIsManager;
      this.bOwnerInfoForm.isManufacturer = data.isManufacturer;
    },
    fillValueOfbusinessDetail(data) {
      this.bDetailForm = {
        company: {
          name: data.company.name,
          brandName: data.company.brandName,
          nationalId: data.company.nationalId,
          registrarNumber: data.company.registrarNumber,
          economicCode: data.company.economicCode,
          taxCode: data.company.taxCode,
          companyType: data.company.companyType,
          isic: data.company.isic,
          guildId: data.companyguildId,
        },
        phones: data.phones,
        email: data.email,
        name: data.name,
        yearOfFoundation: data.yearOfFoundation,
        numberOfEmployee: data.numberOfEmployee,
        permittedSignerNames: data.permittedSignerNames,
      };
    },
    fillValueOfAddess(data) {
      this.bAddressForm = {
        address: {
          title: data.address.title ? data.address.title : 'اطلاعات آدرس',
          cityId: data.address.cityId,
          neighbourhoodId: data.address.neighbourhoodId,
          addressLane: data.address.addressLane,
          postalCode: data.address.postalCode,
          no: data.address.no,
          unit: data.address.unit,
          latitude: data.address.latitude,
          longitude: data.address.longitude,
        },
      };
    },
    fillValueBusinessActivity(data) {
      this.bActivitycatForm = {
        isManufacturer: data.isManufacturer,
        categoryIds: data.merchantCategories.map((el) => {
          return el.categoryId;
        }),
        categoryTypes: data.categoryTypes,
      };
    },
    //Filling component data for in Edit mode --End
      async sendRequestForConfirmation() {
      if (this.businessRegistrationData.status == 'InProgress') {
        return; //No need to  confirm, its olreday confirmed
      }
      if (!this.isCompletingData) {
        return;
      }
      const loader = this.$loading.show();
      await  merchantRepository()
        .merchantRequestConfirmation(
          this.businessRegistrationData.merchantId,
          this.merchantBaseUrl
        )
        .then(() => {
          console.log("this.businessRegistrationData1",this.businessRegistrationData)
          this.businessRegistrationData.status = 'InProgress';
        
           this.$dialog.message.success( 'ارسال درخواست تائید و انتشار کسب و کار با موفقیت انجام شد نتیجه از طریق پیامک به اطلاع شما خواهد رسید', {
              position: 'top-left',
            });
          
           console.log("this.businessRegistrationData2",this.businessRegistrationData)
        })
        .catch((error) => {
          console.log("Auto Request  confirmation error log:",error)
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
